import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';

interface DetailSection8Props {
  submission: CreditSubmission;
}

export default function DetailSection8({ submission }: DetailSection8Props) {
  if (!submission.business_documents || submission.business_documents.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>8. Dokumen Usaha</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {submission.business_documents.map((doc: any, index: number) => (
            <div key={index} className="border rounded-lg p-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="text-sm text-gray-600">Jenis Dokumen</label>
                  <p className="font-medium mt-1">{doc.document_type || '-'}</p>
                </div>
                <div>
                  <label className="text-sm text-gray-600">Nomor</label>
                  <p className="font-medium mt-1">{doc.document_number || '-'}</p>
                </div>
                <div className="md:col-span-2">
                  <label className="text-sm text-gray-600">Keterangan</label>
                  <p className="mt-1">{doc.description || '-'}</p>
                </div>
                {doc.document_url && (
                  <div className="md:col-span-2">
                    <a
                      href={doc.document_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      Lihat Dokumen
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
